<section>
  <app-form-header [menuDefinition]="menuDefinition" (onCancel)="cancel()" [cancelText]="'COMMON.OPEN_RENTAL_OBJECT'">
    <ng-template>
      @if (!dataContext.approvedAt && !dataContext.sentToPlatformAt) {
        <li style="display: inline-flex">
          <button type="button" class="btn btn-outlined additional-button" (click)="onSubmit()">
            {{ 'LETTING.ADVERTISMENT.SAVE_DRAFT' | translate }}
          </button>
        </li>
        <li style="display: inline-flex">
          <button type="button" class="btn btn-primary additional-button" (click)="saveAndSubmit()">
            <img src="assets/icons/save.svg" alt="save" />{{ 'LETTING.ADVERTISMENT.PUBLISH' | translate }}
          </button>
        </li>
      } @else {
        <p class="timestamp">
          {{ 'LETTING.ADVERTISMENT.PUBLISHED_AT' | translate }} {{ dataContext.sentToPlatformAt | date: 'medium' : '' : currentLang }}
        </p>
      }
    </ng-template>
  </app-form-header>
  @if (form) {
    <form class="astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (dataContext.isNew && dataContext.rentalObjectId) {
        <letting-unpublished-warning
          [rentalObjectId]="dataContext.rentalObjectId"
        ></letting-unpublished-warning>
      }
      <section class="astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls.platform" [itemsSource]="platformSelection"></astral-select>
          @if (form.controls.approvedAt) {
            <astral-date-picker [control]="form.controls.approvedAt"></astral-date-picker>
          }
          <astral-input [span]="2" [control]="form.controls.rentalObjectName"></astral-input>
        </astral-layout-group>
      </section>
      @if (dhMarketSelected && dhMarketOptions) {
        <letting-advertisment-market
          [letting]="dataContext"
          [tenants]="tenants"
          [marketOptions]="dhMarketOptions"
          [readonly]="dataContext.approvedAt || dataContext.sentToPlatformAt"
          #marketform
        ></letting-advertisment-market>
        <letting-advertisment-market-area
          [control]="form.controls.dhMarketArea"
          [letting]="dataContext"
          [marketOptions]="dhMarketOptions"
          #marketareaform
        ></letting-advertisment-market-area>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.rentalObjectDocuments"
          [documents]="dataContext.rentalObjectDocuments"
          [type]="RentalObjectDocumentType.InteriorPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="20"
        ></letting-document-control>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.floorPlanDocuments"
          [documents]="dataContext.floorPlanDocuments"
          [type]="RentalObjectDocumentType.FloorPlan"
          [mimeTypes]="pdfOrImageMimes"
          maxFiles="1"
        ></letting-document-control>
        @if (!form.controls.dhMarketArea.value) {
          <letting-document-control
            [isBuilding]="true"
            [parentId]="dataContext.buildingId"
            [control]="form.controls.buildingSurroundingsPhotos"
            [documents]="dataContext.buildingSurroundingsPhotos"
            [type]="BuildingDocumentType.ExteriorPhoto"
            [mimeTypes]="imageMimes"
            maxFiles="10"
          ></letting-document-control>
        }
      }
    </form>
  }
</section>
